import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useCallback, useState } from 'react';
import ddt from '@wix/da-ddt';
import { isMultiImageDeviation } from '../../DeviationViews/_helpers';
import { useZoomBiLogger } from '../../DeviationViews/Full/hooks/useZoomBiLogger';
import MobileMultiArtStage from './MobileMultiArtStage';
import MobileSingleArtStage from './MobileSingleArtStage';
const logger = ddt.createLogger('multifile');
export const MobileArtStage = (props)=>{
    logger.log('MobileArtStage, multi_file_deviation');
    const [zoomedImageSource, setZoomedImageSource] = useState();
    const logZoomBi = useZoomBiLogger(props.deviation);
    const zoomProps = {
        zoomedImageSource,
        isZoomed: !!zoomedImageSource,
        onEnterZoomMode: useCallback((source)=>{
            setZoomedImageSource(source);
            logZoomBi(true);
        }, [
            logZoomBi
        ]),
        onExitZoomMode: useCallback(()=>{
            setZoomedImageSource(undefined);
            logZoomBi(false);
        }, [
            logZoomBi
        ])
    };
    return isMultiImageDeviation(props.deviation) ? /*#__PURE__*/ React.createElement(MobileMultiArtStage, _object_spread({}, props, zoomProps)) : /*#__PURE__*/ React.createElement(MobileSingleArtStage, _object_spread({}, props, zoomProps));
};
MobileArtStage.displayName = 'MobileArtStage';
export default MobileArtStage;

//# sourceMappingURL=MobileArtStage.js.map